/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthenticationOauth2GitHubGet = {
  id: 'authentication.oauth2.github.get',
  tag: 'Authentication',
  summary: 'Login using GitHub over OAuth2',
  description: '',
  method: 'get',
  route: () => `/authentication/oauth2/github`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
